import {
    EVENTS_LOAD_REQUESTED,
    EVENTS_LOAD_SUCCEEDED,
    EVENTS_LOAD_FAILED,
    EVENTS_POLLING_REQUESTED,
    EVENTS_POLLING_SUCCEEDED,
    EVENTS_POLLING_FAILED,
    EVENTS_POLLING_CANCELED,
    EVENT_LOAD_REQUESTED,
    EVENT_LOAD_SUCCEEDED,
    EVENT_LOAD_FAILED,
    EVENT_CREATE_REQUESTED,
    EVENT_CREATE_SUCCEEDED,
    EVENT_CREATE_FAILED,
    EVENT_UPDATE_REQUESTED,
    EVENT_UPDATE_SUCCEEDED,
    EVENT_UPDATE_FAILED,
    EVENTS_SET,
    EVENTS_MERGE,
    EVENT_SET
} from './constants';

import {
    RequestLoadEventsAction,
    SucceededLoadEventsAction,
    FailedLoadEventsAction,
    RequestPollingEventsAction,
    SucceededPollingEventsAction,
    FailedPollingEventsAction,
    CanceledPollingEventsAction,
    RequestLoadEventAction,
    SucceededLoadEventAction,
    FailedLoadEventAction,
    RequestCreateEventAction,
    SucceededCreateEventAction,
    FailedCreateEventAction,
    RequestUpdateEventAction,
    SucceededUpdateEventAction,
    FailedUpdateEventAction,
    SetEventsAction,
    MergeEventsAction,
    SetEventAction
} from './types';

export function requestloadEvents(): RequestLoadEventsAction {
    return {
        type: EVENTS_LOAD_REQUESTED,
        meta: {
            logentries: true
        }
    };
}

export function succeededLoadEvents(response: any): SucceededLoadEventsAction {
    return {
        type: EVENTS_LOAD_SUCCEEDED,
        payload: response
    };
}

export function failedLoadEvents(error: any): FailedLoadEventsAction {
    return {
        type: EVENTS_LOAD_FAILED,
        payload: error,
        error: true
    };
}

export function requestPollingEvents(): RequestPollingEventsAction {
    return {
        type: EVENTS_POLLING_REQUESTED
    };
}

export function succeededPollingEvents(
    response: any
): SucceededPollingEventsAction {
    return {
        type: EVENTS_POLLING_SUCCEEDED,
        payload: response
    };
}

export function failedPollingEvents(error: any): FailedPollingEventsAction {
    return {
        type: EVENTS_POLLING_FAILED,
        payload: error,
        error: true
    };
}

export function canceledPollingEvents(): CanceledPollingEventsAction {
    return {
        type: EVENTS_POLLING_CANCELED
    };
}

export function requestLoadEvent(eventId: number): RequestLoadEventAction {
    return {
        type: EVENT_LOAD_REQUESTED,
        payload: {
            eventId
        }
    };
}

export function succeededLoadEvent(response: any): SucceededLoadEventAction {
    return {
        type: EVENT_LOAD_SUCCEEDED,
        payload: response
    };
}

export function failedLoadEvent(error: any): FailedLoadEventAction {
    return {
        type: EVENT_LOAD_FAILED,
        payload: error,
        error: true
    };
}

export function requestCreateEvent(data: any): RequestCreateEventAction {
    return {
        type: EVENT_CREATE_REQUESTED,
        payload: {
            data
        },
        meta: {
            logentries: true
        }
    };
}

export function succeededCreateEvent(
    response: any
): SucceededCreateEventAction {
    return {
        type: EVENT_CREATE_SUCCEEDED,
        payload: response
    };
}

export function failedCreateEvent(error: any): FailedCreateEventAction {
    return {
        type: EVENT_CREATE_FAILED,
        payload: error,
        error: true
    };
}

export function requestUpdateEvent(
    eventId: number,
    data: any
): RequestUpdateEventAction {
    return {
        type: EVENT_UPDATE_REQUESTED,
        payload: {
            eventId,
            data
        },
        meta: {
            logentries: true
        }
    };
}

export function succeededUpdateEvent(
    response: any
): SucceededUpdateEventAction {
    return {
        type: EVENT_UPDATE_SUCCEEDED,
        payload: response
    };
}

export function failedUpdateEvent(error: any): FailedUpdateEventAction {
    return {
        type: EVENT_UPDATE_FAILED,
        payload: error,
        error: true
    };
}

export function setEvents(data: any): SetEventsAction {
    return {
        type: EVENTS_SET,
        payload: data,
        meta: {
            keyBy: 'id'
        }
    };
}

export function mergeEvents(data: any): MergeEventsAction {
    return {
        type: EVENTS_MERGE,
        payload: data,
        meta: {
            keyBy: 'id'
        }
    };
}

export function setEvent(data: any): SetEventAction {
    return {
        type: EVENT_SET,
        payload: data
    };
}
